/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoutedEligibilityInsuranceContext
 */
export interface RoutedEligibilityInsuranceContext {
    /**
     * 
     * @type {string}
     * @memberof RoutedEligibilityInsuranceContext
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof RoutedEligibilityInsuranceContext
     */
    payor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoutedEligibilityInsuranceContext
     */
    type: RoutedEligibilityInsuranceContextTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RoutedEligibilityInsuranceContext
     */
    state?: string;
}


/**
 * @export
 */
export const RoutedEligibilityInsuranceContextTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay'
} as const;
export type RoutedEligibilityInsuranceContextTypeEnum = typeof RoutedEligibilityInsuranceContextTypeEnum[keyof typeof RoutedEligibilityInsuranceContextTypeEnum];


/**
 * Check if a given object implements the RoutedEligibilityInsuranceContext interface.
 */
export function instanceOfRoutedEligibilityInsuranceContext(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function RoutedEligibilityInsuranceContextFromJSON(json: any): RoutedEligibilityInsuranceContext {
    return RoutedEligibilityInsuranceContextFromJSONTyped(json, false);
}

export function RoutedEligibilityInsuranceContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoutedEligibilityInsuranceContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'],
        'payor_name': !exists(json, 'payor_name') ? undefined : json['payor_name'],
        'type': json['type'],
        'state': !exists(json, 'state') ? undefined : json['state'],
    };
}

export function RoutedEligibilityInsuranceContextToJSON(value?: RoutedEligibilityInsuranceContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payor_id': value.payor_id,
        'payor_name': value.payor_name,
        'type': value.type,
        'state': value.state,
    };
}

